import * as React from 'react'

import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { Flex, Text } from '@chakra-ui/react'

import {
  Loading,
  SideMenuLayoutBreadcrumb,
  SideMenuLayoutContentLayout,
} from '@enechain/ecloud-designsystem'

import { EditApiKeyForm } from '~/pages/ApiKeys/components/EditApiKeyForm'
import { useApiKey } from '~/pages/ApiKeys/hooks/useApiKey'

export const ApiKeyEdit: React.FC<{ apiKeyId: string }> = ({ apiKeyId }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const apiKey = useApiKey(apiKeyId)

  return (
    <SideMenuLayoutContentLayout
      header={
        <Flex alignItems="center" justifyContent="space-between" width="full">
          <SideMenuLayoutBreadcrumb
            items={[
              {
                label: t('pages.api_keys.title'),
                onClick: () => {
                  void navigate({ to: '/api_keys' })
                },
              },
              {
                label: apiKey.name,
                onClick: () => {
                  void navigate({
                    to: '/api_keys/$apiKeyId',
                    params: { apiKeyId },
                  })
                },
              },
              {
                label: t('pages.api_keys.edit.title'),
                bold: true,
              },
            ]}
          />
        </Flex>
      }
    >
      <Flex
        flexDirection="column"
        gap="6"
        maxWidth="1280px"
        margin="auto"
        padding="2"
      >
        <Flex flexDirection="column" gap="1">
          <Text textStyle="headerLg" color="Text.highEmphasis">
            {t('pages.api_keys.edit.title')}
          </Text>
          <Text textStyle="textMd" color="Text.midEmphasis">
            {t('pages.api_keys.edit.description')}
          </Text>
        </Flex>
        <React.Suspense fallback={<Loading />}>
          <EditApiKeyForm apiKey={apiKey} />
        </React.Suspense>
      </Flex>
    </SideMenuLayoutContentLayout>
  )
}
